export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      serviceForMock = _ref.serviceForMock,
      requestForMock = _ref.requestForMock,
      mock = _ref.mock,
      faker = _ref.faker,
      tools = _ref.tools;
  return {
    // 年龄组列表
    tourList: function tourList(data) {
      return request({
        url: '/config/ageGroupList',
        method: 'get',
        data: data
      });
    },
    ageGroupAdd: function ageGroupAdd(data) {
      return request({
        url: '/config/ageGroupAdd',
        method: 'post',
        data: data
      });
    },
    ageGroupUpd: function ageGroupUpd(data) {
      return request({
        url: '/config/ageGroupUpd',
        method: 'post',
        data: data
      });
    },
    ageGroupDel: function ageGroupDel(data) {
      return request({
        url: '/config/ageGroupDel',
        method: 'post',
        data: data
      });
    }
  };
});